import { BaseEntity } from "./baseEntity";

export interface Setting extends BaseEntity {
    name: string;
    value?: string;
}

/**
 * Unità di misura delle quantità. È solo un'etichetta: l'applicazione non converte nulla,
 * l'operatore inserisce i numeri già nell'unità configurata e le tariffe di listino devono
 * essere espresse nella stessa.
 *
 * Si sceglie in avviamento e non si cambia più: con movimenti già a sistema, reinterpretare
 * una giacenza di 5.652.867 come tonnellate anziché chilogrammi sballa le fatture di tre
 * ordini di grandezza.
 */
export enum QuantityUnit {
    KG = "KG",
    QT = "QT",
    TN = "TN",
}

/** Tolleranza sui carichi da nave quando l'impostazione manca: la stessa del server. */
export const DEFAULT_SHIP_LOAD_TOLERANCE = 5;

export enum SettingName {
    QuantityUnit = "QuantityUnit",
    MailSmtpSettings = "MailSmtpSettings",
    /** Magazzino Mexal dello stabilimento, assegnato ai contratti alla creazione. */
    DefaultWarehouse = "DefaultWarehouse",
    /** Residuo sdoganato sotto il quale si avvisa l'operatore. */
    ClearedWarningThreshold = "ClearedWarningThreshold",
    /** Percentuale oltre il contrattuale entro cui i carichi da nave si accettano con un avviso. */
    ShipLoadTolerancePercent = "ShipLoadTolerancePercent",
    /** Sigla, serie e causale dei documenti creati su Mexal, in JSON: vedi {@link MexalDocumentSettings}. */
    MexalDocuments = "MexalDocuments",
    /** Intestazione dei report per i clienti, su più righe. */
    ReportHeader = "ReportHeader",
    /** Logo dei report, come data URL PNG o JPEG. */
    ReportLogo = "ReportLogo",
}

/** Come si crea su Mexal uno dei documenti dell'applicazione. */
export interface MexalDocumentKind {
    /** Sigla documento, es. CL. */
    sign: string;
    /** Serie di numerazione. */
    series: number;
    /** Causale di magazzino: 0 lascia quella predefinita della sigla. */
    reason: number;
    /** Modulo di stampa Mexal: serve alla bolla di scarico. */
    printModule?: string;
}

/** Valore dell'impostazione {@link SettingName.MexalDocuments}. */
export interface MexalDocumentSettings {
    /** Carico: scarichi nave e lotti che ricevono merce da una M.A.D. */
    load: MexalDocumentKind;
    /** Scarico: storni dei carichi e lotti che cedono merce a una M.A.D. */
    unload: MexalDocumentKind;
    /** Movimento fra silos: trasferimento, pulitura, cambio deposito, riconsegna. */
    transfer: MexalDocumentKind;
    /** Bolla di scarico emessa alla bollettazione del buono. */
    deliveryNote: MexalDocumentKind;
}

/** Stessi default del server: un'impostazione assente o parziale vale così. */
export const defaultMexalDocumentSettings: MexalDocumentSettings = {
    load: { sign: 'IC', series: 1, reason: 0 },
    unload: { sign: 'IS', series: 1, reason: 0 },
    transfer: { sign: 'BD', series: 1, reason: 0 },
    deliveryNote: { sign: 'BS', series: 1, reason: 0 },
};
